import ErrorBoundary from '../components/ErrorBoundary';
import { MetadataInfo } from './metadataWidgets';
import { useNonLoggedTopBarStyles } from './NonLoggedTopBar.styles';

export default function NonLoggedTopBar() {
  const { styles } = useNonLoggedTopBarStyles();
  return (
    <ErrorBoundary>
      <div className={styles.nonLoggedTopBar}>
        <MetadataInfo canOpenChangelog={false} />
      </div>
    </ErrorBoundary>
  );
}
